import { FILTER_LS_KEYS } from '@/utils/okr-elements/filters'

export const LS_KEYS = {
  ...FILTER_LS_KEYS,
  LAST_ROUTE_PATH: 'LAST_ROUTE_PATH'
}
